import {
  ADD_ADMIN_ROLE_LOADING,
  ADD_ADMIN_ROLE_SUCCESS,
  EMPTY_ROLE,
  EMPTY_SELECTED_ROLE,
  FETCH_ALL_PERMISSIONS_ERROR,
  FETCH_ALL_PERMISSIONS_SUCCESS,
  FETCH_ALL_ROLES_SUCCESS,
  FETCH_ALL_ROLES_ERROR,
  SELECT_ROLE,
  EMPTY_ROLES,
  OPEN_ADD_ROLE_MODAL,
} from "constants/ActionTypes";

const INIT_STATE = {
  roles: [],
  selectedRole: {},
  emptyRole: true,
  emptyPermission: true,
  alertMessage: "",
  loadingPermissions: true,
  loadingAddRole: false,
  permissions: [],
  openAddRoleModalState: false,
  openEditRoleDrawerState: false,
  loadingRoles: true,
  loadingEditRole: false,
  showErrorMessage: false,
  showSuccessMessage: false,
};

export default (state = INIT_STATE, action) => {
  // console.log({action})
  switch (action.type) {
    case FETCH_ALL_ROLES_SUCCESS:
      // debugger
      return {
        ...state,
        roles: action.payload,
        emptyRole: false,
      };
    case FETCH_ALL_ROLES_ERROR:
      return {
        ...state,
        alertMessage: action.payload,
        showErrorMessage: true,
        showSuccessMessage: false,
        emptyRole: false,
      };
      case EMPTY_ROLE:
        return {
          ...state,
          emptyRole: true,
          alertMessage: "There are no Roles presently",
        };
        case EMPTY_ROLES: {
          return INIT_STATE
        }
    case SELECT_ROLE: {
      const selectedRole = state.roles.find(
        (role) => action.payload === role.RoleId
      );
    
      return {
        ...state,
        selectedRole,
      };
    }
    case EMPTY_SELECTED_ROLE:{
      return {
        ...state,
        selectedRole: {},
      };
    }
    case ADD_ADMIN_ROLE_SUCCESS:{
      return {
        ...state,
        roles: [...state.roles, action.payload],
        loadingAddRole: false,
      };
    }
    case ADD_ADMIN_ROLE_SUCCESS:{
      return {
        ...state,
        roles: [...state.roles, action.payload],
        loadingAddRole: false,
      };
    }
    case ADD_ADMIN_ROLE_LOADING:{
      return {
        ...state,
        loadingAddRole: true,
      };
    }
    case ADD_ADMIN_ROLE_LOADING:{
      return {
        ...state,
        loadingAddRole: false,
        alertMessage: action.payload === ""
        ? "An error occured in adding roles"
        : action.payload,
      };
    }
    case FETCH_ALL_PERMISSIONS_SUCCESS:{
      return {
        ...state,
        permissions: action.payload,
        loadingPermissions: false,
        emptyPermission: false,
      };
    }
    case OPEN_ADD_ROLE_MODAL: {
      return {
        ...state,
        openAddRoleModal: true
      }
    }
    case FETCH_ALL_PERMISSIONS_ERROR: {
      return {
        ...state,
        loadingPermissions: false,
        alertMessage:action.payload === ""
        ? "An error occured in fetching permissions"
        : action.payload,
      };
    }
    default:
      return state;
  }
};
